<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-06 18:28:13
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-13 11:06:56
-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
			<div class="hint-tips" v-if="isAllSync && sync_info">
				<div class="hint-content font-h4-regular fz-14">
					<i class="el-icon-info tips-icon"></i>
					由于官方接口限制，每20分钟仅可同步一次【全量商品】{{ sync_info.partner_name }} 已于 {{ sync_info.sync_time }} 进行【全量同步商品】请在
					<span class="yx-color-warning">{{ sync_info.valid_time }}</span>
					后重试，或使用【同步指定活动】
				</div>
			</div>

			<el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm" label-width="140px">
				<el-form-item label="同步内容" prop="activityProductStatus">
					<el-radio-group style="display: flex" v-model="checked" @change="clearForm()">
						<el-radio style="margin-right: 2px" border :label="0">同步指定商品</el-radio>
						<el-radio style="margin-right: 2px" border :label="1">同步指定活动</el-radio>
						<el-radio style="margin-right: 2px" border :label="2">全量同步商品</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="审核状态" prop="product_status" v-if="$isKs(platformId) && [1, 2].includes(checked)">
					<el-select v-model="product_status" placeholder="请选择" style="width: 255px">
						<el-option v-for="(item, index) in productStatusOptions" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<template v-if="!isAllSync">
					<el-form-item label="机构名称" prop="authority_id">
						<commander-select
							style="width: 255px"
							:platformId="platformId"
							v-model="form['authority_id']"
							:show-all="true"
							@change="commanderChange"
						></commander-select>
					</el-form-item>
					<el-form-item label="活动ID" prop="item_id" v-if="form.authority_id">
						<el-select
							v-scroll-lazy-load="{
								loadData: activityLoadData,
								distance: 50,
								delay: 300,
								scrollBody: '.el-scrollbar__wrap',
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
							:key="form.authority_id"
							style="width: 255px"
							v-model="formItem_id"
							filterable
							remote
							reserve-keyword
							placeholder="请输入活动ID或活动名称"
							@change="handleSelectActivity"
							:remote-method="activityRemoteMethod"
							:loading="activityPage.activityLoading"
						>
							<!-- <el-option v-if="isPureNumber(this.activityPage.query) && activityPage.activityOptions.length === 0" :label="this.activityPage.query" :value="this.activityPage.query"></el-option> -->
							<el-option
								v-for="item in activityPage.activityOptions"
								:key="item.activity_id"
								:label="`${item.activity_name}(${item.third_activity_id})`"
								:value="item.activity_id"
							></el-option>
						</el-select>
					</el-form-item>
					<div style="margin-left: 140px" class="mb-18" v-if="form.authority_id">
						<div class="fz-12">
							未同步过的活动，仅支持输入完整的活动ID。
							<span class="yx-color-primary" @click="goToUrl">如何获取活动ID？</span>
						</div>
						<div class="fz-12">已同步过活动列表的活动。可输入活动名称或ID进行搜索</div>
					</div>
					<el-form-item v-if="isShopSync" label="商品ID/名称" prop="item_id1">
						<el-select
							v-scroll-lazy-load="{
								loadData: goodLoadData,
								distance: 50,
								delay: 300,
								scrollBody: '.el-scrollbar__wrap',
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
							allow-create
							style="width: 255px"
							v-model="form.item_id1"
							filterable
							remote
							reserve-keyword
							placeholder="请输入商品ID或商品名称"
							:remote-method="goodRemoteMethod"
							:loading="productPage.goodLoading"
						>
							<el-option
								v-for="item in productPage.goodOptions"
								:key="item.third_product_id"
								:label="item.product_name"
								:value="item.third_product_id"
							></el-option>
						</el-select>
					</el-form-item>
				</template>

				<!-- <div class="mt-8 desc fz-12">指定商品信息，同步更快</div> -->
			</el-form>
			<synchronization-list :platformId="platformId" v-if="isAllSync" @change="synchronCallback"></synchronization-list>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit" :loading="loading">确认同步</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import { activitySync } from '@/api/secondColonelManage';
import { activityType } from '@/utils/dataMap';
import { syncProductList, syncActivityList } from '@/api/shopManage';
import synchronizationList from '@/modules/async/goods/synchronizationList.vue';
import commanderSelect from '@/components/commanderSelect/index.vue';
export default {
	name: 'chooseAsyncTaskDialog',
	props: {
		title: {
			type: String,
			default: '同步团长商品',
		},
		sync_info: {
			type: Object,
			default: () => {
				return null;
			},
		},
	},
	components: {
		synchronizationList,
		commanderSelect,
	},
	data() {
		return {
			dialogVisible: false,
			checked: 0,
			formItem_id: '',
			form: {
				item_id: '',
				item_id1: '',
				authority_id: '',
			},
			rules: {
				item_id: { required: true, message: '请输入活动ID', trigger: 'blur' },
				item_id1: { required: true, message: '请输入商品ID或商品名称', trigger: 'blur' },
				authority_id: { required: true, message: '请选择机构ID', trigger: 'bur' },
			},
			platformId: '',
			loading: false,

			productPage: {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			},
			activityPage: {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			},
			product_status: 2,
			productStatusOptions: [
				{
					label: '全部',
					value: 0,
				},
				{
					label: '待审核',
					value: 1,
				},
				{
					label: '审核通过',
					value: 2,
				},
				{
					label: '审核拒绝',
					value: 3,
				},
				{
					label: '已失效',
					value: 5,
				},
			],
			institution_id: '',
			team_id: '',
		};
	},
	computed: {
		isShopSync() {
			return this.checked === 0;
		},
		isAllSync() {
			return this.checked === 2;
		},
	},
	created() {},
	methods: {
		isPureNumber(value) {
			// 判断是否为纯数字
			// 处理null和undefined的情况
			if (value === null || value === undefined) {
				return false;
			}
			// 空字符串直接返回false
			if (value === '') {
				return false;
			}

			// 正则表达式匹配纯数字（包括整数和小数，但不包括科学计数法）
			const reg = /^[-+]?(\d+)(\.\d+)?$/;

			return reg.test(value);
		},
		show(platformId) {
			this.platformId = platformId;
			this.dialogVisible = true;
		},
		commanderChange(obj) {
			this.activityPage.activityOptions = [];
			this.synchronCallback(obj);
			this.getActivityList();
		},
		handleClose() {
			this.dialogVisible = false;
			this.checked = 0;
			this.form = {
				item_id: '',
				item_id1: '',
				authority_id: '',
			};
			this.formItem_id = '';
			this.productPage = {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.activityPage = {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.$refs.ruleForm.resetFields();
		},
		clearForm() {
			this.form.authority_id = '';
			this.institution_id = '';
			this.form = {
				item_id: '',
				item_id1: '',
				authority_id: '',
			};
			this.formItem_id = '';
			this.productPage = {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.activityPage = {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.$refs.ruleForm.resetFields();
		},
		submit: debounce(function () {
			const { checked, isAllSync, platformId, institution_id } = this;
			const { authority_id } = this.form;
			if (!authority_id && this.isAllSync) return this.$message.error('请选择要同步的团长账号，如无法选中团长请等待倒计时结束后再进行选择');
			let isAllSyncParams = { platform_id: platformId, authority_id, institution_id };
			if (this.$isKs(platformId) && [1, 2].includes(checked)) {
				isAllSyncParams = { ...isAllSyncParams, product_status: this.product_status };
			}
			if (isAllSync) return this.activitySync(isAllSyncParams);
			this.$refs.ruleForm.validate(valid => {
				if (!valid) return;
				const { item_id } = this.form;
				let isAllSyncParams = checked ? { item_id } : this.form;
				if (this.$isKs(platformId) && [1, 2].includes(checked)) {
					isAllSyncParams = { ...isAllSyncParams, product_status: this.product_status };
				}
				this.activitySync({ ...isAllSyncParams, platform_id: platformId, authority_id: this.form.authority_id });
			});
		}, 500),
		async activitySync(params = {}) {
			const { platformId, team_id, institution_id } = this;
			const { authority_id, item_id, item_id1 } = this.form;
			try {
				this.loading = true;
				const { code, data } = await activitySync({ type: activityType.goodsLibrary, ...params, platform_id: platformId });
				this.loading = false;
				if (code !== 0) return;
				let callback_obj = {
					task_id: data.task_id,
					team_id,
					institution_id,
					authority_id,
					item_id,
					item_id1,
					activityType: activityType.goodsLibrary,
					product_status: this.product_status,
					regimentalChecked: this.checked,
				};
				this.$emit('startAsyncTask', callback_obj);
				this.handleClose();
			} catch (error) {
				this.$message.error(error);
				this.loading = false;
			}
		},
		goToUrl() {
			window.open('https://yangxuan.feishu.cn/docs/doccnLUXeHaN529JVHDZB0Ky80r');
		},
		activityRemoteMethod: debounce(function (query) {
			this.activityPage.query = query;
			this.activityPage.page_index = 1;
			this.activityPage.activityOptions = [];
			this.getActivityList();
		}, 300),
		async getActivityList() {
			this.activityPage.page_index == 1 && (this.activityPage.activityLoading = true);
			try {
				const res = await syncActivityList({
					platform_id: this.platformId,
					page_index: this.activityPage.page_index,
					page_size: this.activityPage.page_size,
					q: this.activityPage.query,
					authority_id: this.form.authority_id,
					req_source_type: 1,
				});
				this.activityPage.activityOptions.push(...res.data.list);
				this.activityPage.page_index = res.data.page.page_index;
				this.activityPage.page_has = res.data.page.page_has;
			} finally {
				this.activityPage.activityLoading = false;
			}
			// setTimeout(() => {
			//   this.activityPage.activityLoading = false;
			//   this.activityPage.activityOptions.push(...this.list.filter(item => {
			//     return item.label.toLowerCase()
			//       .indexOf(this.activityPage.query.toLowerCase()) > -1;
			//   }))
			//   console.log(this.activityPage.activityOptions)
			// }, 200);
		},
		synchronCallback(obj) {
			const { authority_id, id: institution_id, team_id } = obj;
			this.form.authority_id = authority_id;
			this.institution_id = institution_id;
			this.team_id = team_id;
			this.formItem_id = '';
			this.form.item_id = '';
		},

		goodRemoteMethod: debounce(function (query) {
			this.productPage.query = query;
			this.productPage.page_index = 1;
			this.productPage.goodOptions = [];
			this.getProductLis();
		}, 300),

		async getProductLis() {
			if (!isNaN(this.formItem_id)) {
				this.productPage.page_index == 1 && (this.productPage.goodLoading = true);
				try {
					const res = await syncProductList({
						activity_id: this.formItem_id,
						page_index: this.productPage.page_index,
						page_size: this.productPage.page_size,
						product_search: this.productPage.query,
						audit_status: '-1',
						platform_id: this.platformId,
					});
					this.productPage.goodOptions.push(...res.data.list);
					this.productPage.page_index = res.data.page.page_index;
					this.productPage.page_has = res.data.page.page_has;
				} catch (e) {}
				this.productPage.goodLoading = false;
			}
		},

		activityLoadData() {
			if (this.activityPage.page_has && !this.activityPage.goodLoading) {
				this.activityPage.page_index = this.activityPage.page_index + 1;
				this.getActivityList();
			}
		},
		goodLoadData() {
			if (this.productPage.page_has && !this.productPage.goodLoading) {
				this.productPage.page_index = this.productPage.page_index + 1;
				this.getProductLis();
			}
		},
		handleSelectActivity() {
			const val = this.activityPage.activityOptions.find(item => {
				return item.activity_id == this.formItem_id;
			});
			this.form.item_id = val?.third_activity_id || this.formItem_id;
			this.form.item_id1 = '';
			this.goodRemoteMethod();
		},
	},
};
</script>

<style lang="less" scoped>
.el-input {
	width: 212px;
}
.desc {
	margin-left: 100px;
}
.hint-tips {
	margin-bottom: 24px;
	border-radius: 4px;
	border: 1px solid #bdd5ff;
	background: #f0f5ff;
	.hint-content {
		padding: 12px 31px 12px 16px;
		.tips-icon {
			font-size: 16px;
			color: @color-primary;
		}
	}
}
</style>
